import ModalWindow from 'components/molecules/ModalWindow'
import { CONSTS } from 'config/objectConst'
import { Link, useNavigate } from 'react-router-dom'
import { useSwitcher } from 'shared/hooks'
import { Button } from 'shared/ui'

import css from './style.module.scss'

export function Cancel({ isChanged }: { isChanged?: boolean }) {
	return isChanged ? (
		<WithConfirm />
	) : (
		<Button
			as={Link}
			className={css.finishAction}
			to='/campaigns'
			variant='bordered-dark'
		>
			Cancel
		</Button>
	)
}

function WithConfirm() {
	const switcher = useSwitcher()
	const navigate = useNavigate()

	return (
		<>
			<Button
				className={css.finishAction}
				onClick={switcher.on}
				variant='bordered-dark'
			>
				Cancel
			</Button>

			<ModalWindow
				closeHandler={switcher.off}
				closeText='No'
				confirmHandler={() => navigate('/campaigns')}
				confirmText='Yes'
				open={switcher.isOn}
				{...CONSTS.confirmationDialogs[1.3]}
			/>
		</>
	)
}
